import { GSButton, GSInfoGroup } from "golfstatus_react_components";
import { getDateTimeOn } from "../../../helpers/Dates";
import { getStateColor } from "../../../helpers/Converters";
import { getRoundName } from "../../../hooks/round/roundHooks";
import { faBolt, faCircleCheck, faPen, faSpinner, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { checkInTeam, checkOutTeam } from "../../../reducers/checkinSlice";
import { useMatch, useNavigate } from "react-router-dom";

const TournamentTeamRoundCheckinItem = (props) => {
  const { teamRound, style, pending } = props;

  const { tournamentRound, checkIn } = teamRound ?? {};

  const match = useMatch("/:tournamentID/*")
  const tournamentID = match.params.tournamentID

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const checkTeamIn = () => {
    if (checkIn?.id) dispatch(checkInTeam(checkIn.id));
  };

  const checkTeamOut = () => {
    if (checkIn?.id) dispatch(checkOutTeam(checkIn.id));
  };

  const getRoundCheckinButton = () => {
    if(pending){
      return <GSButton
      isDisabled={true}
        title="Check In"
        type="grey"
        buttonIcon={faSpinner}
      />;
    }
    if (!checkIn) {
      return <GSButton
        title="Hole Assignments"
        type="grey"
        buttonIcon={faBolt}
        onClick={() => {navigate(`/${tournamentID}/rounds/${tournamentRound?.id}/hole-assignments`)}}
      />;
    }
    if (checkIn?.checkedInAt) {
      return (
        <GSButton
          isDisabled={tournamentRound?.state !== "live"}
          title="Checked In"
          type="black pill secondary"
          buttonIcon={faUserCheck}
          onClick={checkTeamOut}
        />
      );
    }

    return (
      <GSButton
        isDisabled={tournamentRound?.state !== "live"}
        title="Check In"
        type="grey"
        buttonIcon={faCircleCheck}
        onClick={checkTeamIn}
      />
    );
  };

  const roundName = {
    sectionItems: [
      {
        type: "primary no-wrap",
        value: `Round ${getRoundName(tournamentRound)}`,
      },
    ],
  };

  const roundInfo = {
    sectionItems: [
      {
        type: "secondary no-wrap",
        value: `${getDateTimeOn(tournamentRound?.startAt)}` ?? `TBD`,
      },
      {
        type: "secondary no-wrap",
        value: checkIn?.roundHoleAssignment?.roundCourse?.name,
      },
    ],
  };

  const notAssignend = {
    sectionItems: [
      {
        type: "secondary no-wrap",
        value: `Not yet assigned.`,
      },
    ],
  };

  const roundState = {
    sectionItems: [
      {
        type: " no-wrap",
        value: (
          <GSButton
            type={`secondary pill ${getStateColor(tournamentRound)}`}
            title={tournamentRound?.state}
            
          ></GSButton>
        ),
      },
    ],
  };

  const roundActions = {
    sectionItems: [
      {
        type: " no-wrap full-width",
        value: getRoundCheckinButton(),
      },
    ],
  };

  const editRound = {
    sectionItems: [
      {
        type: " no-wrap full-width",
        value: <GSButton type="grey" buttonIcon={faPen} onClick={() => {navigate(`/${tournamentID}/rounds/${tournamentRound?.id}/details`)}}/>,
      },
    ],
  };

  let group = [
    {
      fit: "stretch",
      sections: [roundName, checkIn ? roundInfo : notAssignend, roundState],
    },
    {
      sections: [roundActions],
    },
    {
      sections: [editRound],
    },
  ];
  return (
    <tournament-team-round-check-in-item style={style}>
      <GSInfoGroup listType="mobile-vertical" dataGroups={group} />
    </tournament-team-round-check-in-item>
  );
};

export default TournamentTeamRoundCheckinItem;
